import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
// import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDtzScu6HKEX4QKEyeb35UXJZndy4-eYqI",
  authDomain: "edge-web-f7e3b.firebaseapp.com",
  databaseURL: "https://edge-web-f7e3b-default-rtdb.firebaseio.com",
  projectId: "edge-web-f7e3b",
  storageBucket: "edge-web-f7e3b.appspot.com",
  messagingSenderId: "786653402275",
  appId: "1:786653402275:web:4fdf5ce5d6fb8d07bc9b16",
  measurementId: "G-N2MFJDQXN5",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const storage = getStorage(app);
const database = getDatabase(app);

// Initialize Firebase Cloud Messaging
let messaging = null;
try {
  // Check if browser supports notifications
  if (typeof window !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window) {
    messaging = getMessaging(app);
  }
} catch (error) {
  console.log('Firebase messaging not supported in this environment:', error);
}

export { app, auth, storage, database, messaging, getToken, onMessage };
